import React, { ReactElement } from 'react'
import SecondaryHeader from '../Headers/SecondaryHeader/SecondaryHeader'

const SecondaryLayout = ({ children, title }): ReactElement => {
  return (
    <>
      <div className=' h-full relative min-h-full  '>
        <SecondaryHeader title={title} />
        <div className='md:max-w-7xl md:mx-auto h-[calc(100%_-_48px)] min-h-[calc(100%_-_48px)]'>
          {children}
        </div>
      </div>
    </>
  )
}

export default SecondaryLayout
